import React from 'react'
import styled from 'styled-components'

import { Rating } from 'components/styled/rating'
import { MobileRating } from 'components/styled/rating/mobile'
import { Placement } from '@floating-ui/react-dom-interactions'

export interface RatingButtonProps {
  ownRating?: number
  hideReviews?: boolean
  average?: number
  onRate?: (rate: number) => void
  onResetRate?: () => void
  isLoading?: boolean
  popOverPlacement?: Placement
}

const customProps = [
  'ownRating',
  'hideReviews',
  'average',
  'onRate',
  'onResetRate',
  'isLoading',
  'popOverPlacement',
]

const StyledRating = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !customProps.includes(prop),
})`
  display: initial;
  ${({ theme }) => theme.mediaQuery.tablet} {
    display: none;
  }
`
const StyledMobileRating = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !customProps.includes(prop),
})`
  display: none;

  ${({ theme }) => theme.mediaQuery.tablet} {
    display: initial;
    width: 100%;
  }
`

export const ActionBarRatingButton = ({
  popOverPlacement,
  ...props
}: RatingButtonProps) => {
  return (
    <>
      <StyledRating>
        <Rating popOverPlacement={popOverPlacement} {...props} />
      </StyledRating>
      <StyledMobileRating>
        <MobileRating {...props} />
      </StyledMobileRating>
    </>
  )
}
